export default "/images/3864f796ef014a6979f4c1bbbfd0665b.avif";